/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Brazilian Portuguese (pt) string table · dr-ronlan.html
   English is the source of truth in the HTML; this file supplies the
   Portuguese counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-pt.js.
   Proper names, institution names, journal titles, patent numbers and
   molecular names stay in their original form.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.pt = window.TD_I18N.pt || {};
  Object.assign(window.TD_I18N.pt, {

    /* ── Meta ── */
    'ronlan.docTitle': 'Dr. K. Alvin Ronlán · Pesquisa e trajetória — Transderma',

    /* ── Page header ── */
    'ronlan.headLabel': 'Pesquisa e trajetória',
    'ronlan.headTitle': 'Dr. K. Alvin <em>Ronlán</em>',
    'ronlan.headSub': 'Fundador, Director of R&amp;D. Três décadas de química de fenóis, agora aplicadas à pele.',

    /* ── Quick facts ── */
    'ronlan.facts.label': 'Em resumo',
    'ronlan.facts.bornK': 'Nascimento',
    'ronlan.facts.bornV': '15 de agosto de 1942, Copenhague, Dinamarca',
    'ronlan.facts.domK': 'Residência',
    'ronlan.facts.domV': 'Flórida, Estados Unidos',
    'ronlan.facts.langK': 'Idiomas',
    'ronlan.facts.langV': 'Dinamarquês, sueco, inglês, alemão',
    'ronlan.facts.roleK': 'Cargo atual',
    'ronlan.facts.roleV': 'R&amp;D Director, Alron Chemical Co AB · Cofundador, ProBios Laboratories, Inc.',

    /* ── Education ── */
    'ronlan.eduLabel': 'Formação',
    'ronlan.eduTitle': 'Quatro diplomas,<br><em>três países.</em>',
    'ronlan.edu1h': 'B.Sc. · matemática, física, química',
    'ronlan.edu1p': 'Universidade de Copenhague e Instituto Técnico da Dinamarca.',
    'ronlan.edu2h': 'M.Sc. · física e química',
    'ronlan.edu2p': 'Universidade de Uppsala, Suécia.',
    'ronlan.edu3h': 'Ph.D.',
    'ronlan.edu3p': 'Royal Institute of Technology, Stockholm, Suécia.',
    'ronlan.edu4h': 'Doutor em Ciências',
    'ronlan.edu4p': 'Universidade de Lund, Suécia.',

    /* ── Career ── */
    'ronlan.carLabel': 'Carreira',
    'ronlan.carTitle': 'Da academia<br><em>ao laboratório.</em>',
    'ronlan.carIntro': 'Seis décadas de ensino, pesquisa e química aplicada. Os pontos altos abaixo.',
    'ronlan.car1h': 'Assistente, Universidade de Uppsala',
    'ronlan.car1p': 'Primeiro cargo de ensino durante o mestrado.',
    'ronlan.car2h': 'Assistente de pesquisa, Royal Institute of Technology, Stockholm',
    'ronlan.car2p': 'Seus anos de doutorado em Stockholm.',
    'ronlan.car3h': 'Docente, Universidade de Lund',
    'ronlan.car3p': 'Inicia o trabalho em química de fenóis e oxidação anódica que mais tarde sustentaria a formulação Transderma.',
    'ronlan.car4h': 'Professor adjunto, Universidade de Lund',
    'ronlan.car5h': 'Professor, Universidade de Lund',
    'ronlan.car5p': 'Promovido a professor de química bioorgânica, lidera o grupo de pesquisa sobre antioxidantes fenólicos e radicais catiônicos.',
    'ronlan.car6h': 'Diretor do departamento de química, Universidade de Lund',
    'ronlan.car6p': 'Lidera o departamento de química da Universidade de Lund.',
    'ronlan.car7h': 'Director of R&amp;D, Alron Chemical Co AB',
    'ronlan.car7p': 'Em andamento · funda o laboratório em 1977 para química e física de superfícies e catálise de combustão. No mesmo ano, a Alron Japan, Inc. também é fundada em Tóquio.',
    'ronlan.car8h': 'Professor visitante, University of California, Santa Cruz',
    'ronlan.car8p': 'Aplica a inteligência artificial nascente a problemas químicos e bioquímicos.',
    'ronlan.car9h': 'Cofundador e R&amp;D Director, ProBios Laboratories, Inc.',
    'ronlan.car9p': 'Com Graziella Gallelli Ronlan. Pesquisa e desenvolvimento sediados na Flórida.',
    'ronlan.car10h': 'Consultor, Erco Pharmaceuticals',
    'ronlan.car10p': 'Coautor de patentes sobre produtos de contraste e medicamentos anti-hipertensivos.',
    'ronlan.car11h': 'Expedição à África Oriental',
    'ronlan.car11p': 'Organizou e liderou uma expedição de quatro meses ao Quênia, Tanzânia e Uganda para coleta de plantas medicinais.',

    /* ── Publications ── */
    'ronlan.pubLabel': 'Publicações selecionadas',
    'ronlan.pubTitle': 'Fenóis, antioxidantes,<br><em>radicais catiônicos.</em>',
    'ronlan.pubIntro': 'Dez artigos revisados por pares que mostram a química subjacente às formulações Transderma. A bibliografia completa de 31 artigos está disponível no download do CV.',
    'ronlan.pub1': '<em>Phenol Dehydrogenation. Intramolecular Oxidative Coupling of Dihydropiceatannol.</em> Acta Chem. Scand., 23, 249 (1969). Com Holger Erdtman.',
    'ronlan.pub2': '<em>The Structure of Mezerein, A Major Toxic Principle of Daphne Mezerum L.</em> Tetrahedron Letters, 1970, 4261. Com Börje Wickberg.',
    'ronlan.pub3': '<em>Coupling of Phenols via an Anodically Generated Ion.</em> Chem. Commun., 1971, 1643.',
    'ronlan.pub4': '<em>Anodic Oxidation of Phenolic Compounds. Part II. Products and Mechanisms of the Anodic Oxidation of Hindered Phenols.</em> J. Chem. Soc., C, 1971, 3241. Com V.D. Parker.',
    'ronlan.pub5': '<em>Kinetics and Mechanisms of the Reaction of Organic Cation Radicals and Dications.</em> J. Amer. Chem. Soc., 96, 5108 (1974). Com V.D. Parker e U. Svanholm.',
    'ronlan.pub6': '<em>Anodic Oxidation of Phenolic Compounds. Part V. Anodic Methoxylation of Phenols.</em> J. Chem. Soc. Perk I, 1978, 696.',
    'ronlan.pub7': '<em>Anodic Coupling of Simple Aryl Ethers.</em> Tetrahedron Letters, 1972, 2272.',
    'ronlan.pub8': '<em>The Direct Observation of Intermediates During the Oxidative Cyclization of Phenol Ethers.</em> Acta Chem. Scand., 1974.',
    'ronlan.pub9': '<em>Electrosynthesis of Medium and Large Sized Rings by Oxidative Cyclization.</em> J. Org. Chem., 39, 1014 (1974).',
    'ronlan.pub10': '<em>The Relative Ease of Oxidation of Phenols and Phenol Ethers.</em> Acta Chem. Scand., 1976.',
    'ronlan.pub11': '<em>Systematic Derivation of Chemical Procedures for Transforming Surplus Hazardous Chemicals to Useful Products.</em> Journal of Hazardous Materials, 1984.',
    'ronlan.pubFull': 'A bibliografia completa de 31 artigos revisados por pares está disponível no download do CV.',

    /* ── Patents ── */
    'ronlan.patLabel': 'Patentes',
    'ronlan.patTitle': 'Sete patentes,<br><em>uma central para a pele.</em>',
    'ronlan.patFeatBadge': 'A base da Transderma',
    'ronlan.patFeatTitle': 'US Pat. 20080118449 · Cosmetic Formulations of Piceatannol and Retinoids and Methods of Use Thereof',
    'ronlan.patFeatBody': 'Essa patente é a base química da Transderma. O piceatannol é o ativo principal do Serum R; os retinoides (palmitato de retinila) são o ativo principal do Serum A. A patente descreve como essas duas moléculas agem juntas na pele.',
    'ronlan.patFeatLinkA': 'Comprar Serum R',
    'ronlan.patFeatLinkB': 'Comprar Serum A',
    'ronlan.pat1': 'US Pat. 6,500,465 · Composição desinfetante e esporicida · descontaminação de edifícios.',
    'ronlan.pat2': 'US Pat. 5,540,767 · Composição e método de balanceamento de pneus.',
    'ronlan.pat3': 'US Pat. 5,431,726 · Composição de balanceamento.',
    'ronlan.pat4': 'US Pat. 4,867,792 · Composição de balanceamento de pneus.',
    'ronlan.pat5': 'European Patent EP1196299 · Composições de balanceamento de pneus.',
    'ronlan.pat6': 'European Patent EP0281252 · Composição e método de balanceamento de pneus.',

    /* ── Shop CTA ── */
    'ronlan.ctaLabel': 'A química aplicada',
    'ronlan.ctaTitle': 'A patente está<br><em>dentro do frasco.</em>',
    'ronlan.ctaBody': 'Dois dos cinco sérums Transderma vêm diretamente da patente cosmética do Dr. Ronlán. Comece por eles, ou experimente o sistema inteiro no Discovery Kit.',
    'ronlan.ctaBtnR': 'Serum R · Piceatannol',
    'ronlan.ctaBtnA': 'Serum A · Retinoide',
    'ronlan.ctaBtnKit': 'Discovery Kit · os cinco',

    /* ── PDF download footer ── */
    'ronlan.dlNote': 'Prefere o documento original?',
    'ronlan.dlLink': 'Baixar o CV completo (PDF) →'

  });
})();
